angular.module( 'acme.view.application.importExport.jobExecution', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.importExport.jobExecution.controllers.importExportJobExecutionController',
  'acme.view.application.importExport.jobExecution.controllers.importExportJobExecutionDeleteModalController',
  'acme.view.application.importExport.jobExecution.controllers.importExportCreateJobModalController',
  'acme.view.application.importExport.jobExecution.controllers.importExportDeleteJobModalController',
])

.config(function config( $stateProvider ) {
  var importExportJobExecution = {
    name: 'application.importExport.jobExecution',
    url: '/job/:jobId/execution/:id?:tab',
    views: {
      "subview-main": {
        controller: 'ImportExportJobExecutionController',
        controllerAs: '$ctrl',
        templateUrl: 'views/application/views/importExport/importExportJobExecution/importExportJobExecution.tpl.html'
      }
    },
    data: {
      pageTitle: 'Import Export - Job Execution',
      enablePreferences: true
    }
  };

  $stateProvider
    .state(importExportJobExecution);
});
